import { Link } from 'react-router-dom';
import ArticleLayout from '@/components/ArticleLayout';

const reviews = [
  { title: 'CSSBuy Review 2026', to: '/reviews/cssbuy-review', desc: 'Fees, QC, shipping, warehouse, and overall buying experience.' },
  { title: 'Is CSSBuy Legit?', to: '/reviews/is-cssbuy-legit', desc: 'Legitimacy analysis, payment safety, and scam prevention tips.' },
];

export default function ReviewsPage() {
  return (
    <ArticleLayout
      title="CSSBuy Reviews"
      description="Independent reviews and analysis of CSSBuy features, safety, and user experience."
      breadcrumbs={[
        { label: 'Home', to: '/' },
        { label: 'Reviews', to: '/reviews' },
      ]}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {reviews.map((review) => (
          <Link
            key={review.to}
            to={review.to}
            className="group p-5 bg-background-50 border border-background-200 rounded-xl hover:bg-primary-50 hover:border-primary-200 transition-all"
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary-100 group-hover:bg-primary-200 flex items-center justify-center shrink-0 transition-colors">
                <i className="ri-star-line text-primary-600 text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 mb-1">
                  {review.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{review.desc}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </ArticleLayout>
  );
}